import { render } from "./app.vue?vue&type=template&id=4efaebe0"
import script from "./app.vue?vue&type=script&lang=ts"
export * from "./app.vue?vue&type=script&lang=ts"

import "./app.vue?vue&type=style&index=0&id=4efaebe0&lang=css"
script.render = render

export default script